import {enableProdMode} from '@angular/core';
import {environment} from './environments/environment';
import {bootstrapApplication} from '@angular/platform-browser';
import {AppComponent} from './app/app.component';
import {appConfig} from './app/app.config';
import localeDe from '@angular/common/locales/de';
import localeDeExtra from '@angular/common/locales/extra/de';
import {registerLocaleData} from '@angular/common';

if (environment.production)
{
  enableProdMode();
  window.console.log = () => {};
}
registerLocaleData(localeDe, 'de-DE', localeDeExtra);

bootstrapApplication(AppComponent, appConfig)
  .catch(err => console.error(err));
